import { lazy } from "react";

export default lazy(() =>
  import("./WysiwygActual" /* webpackChunkName: "wysiwyg" */)
);
